// extracted by mini-css-extract-plugin
module.exports = {"paper":"legal-layout_paper__5aSiK","container":"legal-layout_container__WdCjM"};